module.exports = __webpack_public_path__ + "img/co-carbon-m.9218ca30.svg";